import { createFileRoute } from '@tanstack/react-router'
import EditionRights from 'Edition/components/sections/General/EditionRights'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-rights')({
    component: EditionRights,
})
